import VueRouter from 'vue-router';
import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    routes,
});

// router.beforeEach((to, from, next) => {
//     next();
// });

export default router;



// WEBPACK FOOTER //
// ./src/router.js